<!-- mainPromo -->
<div class="mainPromo">
    <h2 class="b-tit">PROMOTION🎉</h2>
    <div class="row g-4 container">
        <ng-container *ngFor="let item of collection;">
            <div class="col-xs-12 col-lg-4">
                <a (click)="handleOnClickBoardNo(item.boardNo)">
                    <div class="imgRwap">
                        <img src="{{item.pathImg}}" alt="">
                    </div>
                    <h2>{{item.title}} </h2>
                    <p>{{item.insUser}} - {{item.insDate}}</p>
                </a>
            </div>
        </ng-container>
    </div>
</div>
<!-- //mainPromo -->